<template>
  <div>
    <!-- Dashboard Layout: Different from TaxResults -->
    <!-- Utilizzo di d-flex e align-items-stretch per garantire che le colonne abbiano la stessa altezza -->
    <div class="row d-flex align-items-stretch">
      <!-- Welcome Message - 4 columns -->
      <div class="col-xl-5 col-lg-12 d-flex flex-column">
        <div class="card bg-hero-primary border-0 rounded-3 welcome-box mb-4 h-100">
          <div class="card-body p-4">
            <div class="row align-items-center">
              <div class="col-lg-8 col-md-8 col-sm-8">
                <div class="border-bottom">
                  <h3 class="text-white fw-semibold mb-1" v-html="t('tdb.welcome.greeting', 'Ciao {username} 👋', { username: getUserName() })"></h3>
                  <span class="text-light mb-1" v-html="t('tdb.welcome.line1', 'Niente ansia e niente stress, è tutto sotto controllo!')"></span>
                </div>

                <div class="d-flex flex-column gap-3">
                  <div class="d-flex align-items-center welcome-status-item">
                    <div class="flex-shrink-0">
                      <i class="material-symbols-outlined">savings</i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-light  mb-0">{{ t('fr.tax_results.accumulated_balance', 'Saldo Accumulato') }}</p>
                      <strong class="text-white fw-bold mb-0">€{{ formatCurrency(lastCalculation.input_data.currentBalance) }}</strong>
                      
                    </div>
                  </div>

                  <div class="d-flex align-items-center welcome-status-item">
                    <div class="flex-shrink-0">
                      <i class="material-symbols-outlined icon-bg">add_card</i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                       <p class="text-light mb-0" v-html="t('tdb.next_payment_label', 'Il prossimo accantonamento')"></p>
                      <strong class="text-white fw-bold mb-0">
                        <span v-if="getNextPayment()">€{{ formatCurrency(getNextPayment().amount) }}</span>
                        <span v-else>Caricamento...</span>
                      </strong>
                     
                    </div>
                  </div>

                  <div class="d-flex align-items-center welcome-status-item">
                    <div class="flex-shrink-0">
                        <i class="material-symbols-outlined text-info" style="background-color: #def1f9;">calendar_month</i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-light mb-0 " v-html="t('fr.liquidity.avg_monthly_rate_small', 'La tua rata mensile')"></p>
                      <strong class="text-white fw-bold mb-0">
                        <span v-if="getAvgMonthlyRate()">€{{ formatCurrency(getAvgMonthlyRate()) }}</span>
                        <span v-else>Caricamento...</span>
                      </strong>
                      
                    </div>
                  </div>

                  <div class="d-flex align-items-center welcome-status-item">
                    <div class="flex-shrink-0">
                        <i class="material-symbols-outlined text-danger" style="background-color: #ffe8d4;">account_balance</i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-light mb-0" v-html="t('fr.liquidity.total_deposits_small', 'Totale Versamenti')"></p>
                      <strong class="text-white fw-bold mb-0">
                        <span v-if="getTotalDeposits()">€{{ formatCurrency(getTotalDeposits()) }}</span>
                        <span v-else>Caricamento...</span>
                      </strong>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4">
                <div class="welcome-img text-center text-sm-end mt-4 mt-sm-0">
                  <img src="@/assets/images/welcome.png" alt="welcome" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Con e senza Smartrate - 8 columns -->
      <div class="col-xl-7 d-flex flex-column">
        <MonthlyFlowChart :schedule="mappedLiquidityResults" v-if="mappedLiquidityResults" class="h-100" />
      </div>
      
    </div>

    <!-- Tax Widgets Row - nascosto se hideTaxWidgets è true -->
    <div class="row" v-if="!hideTaxWidgets">
      <div class="col-lg-6">
        <TaxBreakdownChart
          :title="currentYearTitle"
          :chartTaxTotal="calculateChartAmounts(mappedResults.current).taxAmount"
          :chartInpsVariableTotal="calculateChartAmounts(mappedResults.current).inpsVariableAmount"
          :chartInpsFixedTotal="calculateChartAmounts(mappedResults.current).inpsFixedAmount"
          :chartContribSoggettivo="calculateChartAmounts(mappedResults.current).contribSoggettivo"
          :chartContribIntegrativo="calculateChartAmounts(mappedResults.current).contribIntegrativo"
          :chartContribMaternita="calculateChartAmounts(mappedResults.current).contribMaternita"
          :contributionType="calculateChartAmounts(mappedResults.current).contributionType"
          :fatturato="mappedResults.current?.fatturatoPrecedente || 0"
          :calculationDetails="mappedResults.current?.calculationDetails || null"
          :showSummary="true"
          :year="currentYear - 1"
          :summaryData="{
            fatturato: mappedResults.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(mappedResults.current),
            redditoImponibile: mappedResults.current?.redditoImponibile || (mappedResults.current?.fatturatoPrecedente || 0) * 0.78,
            inpsSaldo: mappedResults.current?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: mappedResults.current?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: mappedResults.current?.previousYearTaxAdvancesPaid || 0, // TODO sbagliati qua
            totaleImposte: mappedResults.current?.totalDue || 0
          }"
        />
      </div>
      <div class="col-lg-6 d-none">
        <TaxBreakdownChart
          :title="nextYearTitle"
          :chartTaxTotal="calculateChartAmounts(mappedResults.predictions).taxAmount"
          :chartInpsVariableTotal="calculateChartAmounts(mappedResults.predictions).inpsVariableAmount"
          :chartInpsFixedTotal="calculateChartAmounts(mappedResults.predictions).inpsFixedAmount"
          :chartContribSoggettivo="calculateChartAmounts(mappedResults.predictions).contribSoggettivo"
          :chartContribIntegrativo="calculateChartAmounts(mappedResults.predictions).contribIntegrativo"
          :chartContribMaternita="calculateChartAmounts(mappedResults.predictions).contribMaternita"
          :contributionType="calculateChartAmounts(mappedResults.predictions).contributionType"
          :fatturato="mappedResults.predictions?.fatturatoPrecedente || mappedResults.current?.fatturatoPrecedente || 0"
          :calculationDetails="mappedResults.predictions?.calculationDetails || null"
          :showSummary="true"
          :year="currentYear"
          :summaryData="{
            fatturato: mappedResults.predictions?.fatturatoPrecedente || mappedResults.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(mappedResults.predictions),
            redditoImponibile: mappedResults.predictions?.redditoImponibile || (mappedResults.predictions?.fatturatoPrecedente || mappedResults.current?.fatturatoPrecedente || 0) * 0.78,
            inpsSaldo: mappedResults.predictions?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: mappedResults.predictions?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: mappedResults.predictions?.previousYearTaxAdvancesPaid || 0,
            totaleImposte: mappedResults.predictions?.totalDue || 0
          }"
        />
      </div>
      <div class="col-lg-6">
        <DeadlinesWidget :results="mappedResults" />
      </div>
    </div>

    <!-- Liquidity Statistics Boxes -->
    <div v-if="mappedLiquidityResults">
      <LiquidityStatsBoxes :schedule="mappedLiquidityResults" />
    </div>

    <!-- Third Row: Liquidity Table -->
    <div class="row mt-0" v-if="mappedLiquidityResults">
      <div class="col-12">
        <LiquidityScheduleTable :schedule="mappedLiquidityResults" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed, ref, onMounted } from 'vue';
import { t } from '@/utils/i18nHelper';
import type { LastCalculationData } from '@/services/authService';
import { calculateProgressiveLiquidity } from '@/services/progressiveLiquidityService';
import { authStore } from '@/stores/auth';
import TaxBreakdownChart from './TaxBreakdownChart.vue';
import DeadlinesWidget from './DeadlinesWidget.vue';
import LiquidityStatsBoxes from './LiquidityStatsBoxes.vue';
import LiquidityScheduleTable from './LiquidityScheduleTable.vue';
import MonthlyFlowChart from './MonthlyFlowChart.vue';

const props = defineProps({
  lastCalculation: {
    type: Object as () => LastCalculationData,
    required: true,
  },
  hideTaxWidgets: {
    type: Boolean,
    default: false,
  },
});

// Reactive state for liquidity data
const liquidityApiResults = ref<any>(null);

const currentYear = new Date().getFullYear();

const currentYearTitle = computed(() =>
  t('fr.tax_results.current_year_title', `Totale ${currentYear}`, { currentYear })
);

const nextYear = currentYear + 1;

const nextYearTitle = computed(() =>
  t('fr.tax_results.next_year_title', `Previsione ${nextYear}`, { nextYear })
);

// Map lastCalculation data to the format expected by TaxResults components
const mappedResults = computed(() => {
  if (!props.lastCalculation?.output_data) {
    return { current: null, predictions: null };
  }

  return {
    current: props.lastCalculation.output_data.current,
    predictions: props.lastCalculation.output_data.predictions
  };
});

// Map liquidity data from API call
const mappedLiquidityResults = computed(() => {
  return liquidityApiResults.value;
});

// Get contribution regime from input data
const contributionRegime = computed(() => {
  return props.lastCalculation?.input_data?.contributionRegime || 'IVS_COMMERCIANTI';
});

// Helper function to calculate correct flat tax rate
const calculateFlatTaxRate = (yearData: any): number => {
  // If API already provides the correct rate, use it
  if (yearData?.aliquotaForfettaria) {
    return yearData.aliquotaForfettaria;
  }
  if (yearData?.aliquotaImpostaSostitutiva) {
    return yearData.aliquotaImpostaSostitutiva;
  }

  // Otherwise calculate based on form data from lastCalculation
  if (props.lastCalculation?.input_data?.isStartup && yearData?.yearsActive <= 5) {
    return 5; // 5% for startups within first 5 years
  }

  return 15; // 15% standard rate
};

const calculateChartAmounts = (data: any) => {
  if (!data) return {
    taxAmount: 0,
    inpsVariableAmount: 0,
    inpsFixedAmount: 0,
    contribSoggettivo: 0,
    contribIntegrativo: 0,
    contribMaternita: 0,
    contributionType: 'INPS'
  };

  // Verifica se è una cassa professionale
  const isProfessional = data.contributionBreakdown !== undefined;

  // Per il grafico sommiamo sempre: saldo + acconti dell'anno corrente
  // Questo mostra tutti i versamenti che l'utente deve fare nell'anno
  const taxAmountRaw = (
    (data.saldoImpostaSostitutiva || data.adjustedTaxBalance || 0) +
    (data.firstAccontoImpostaSostitutiva || 0) +
    (data.secondAccontoImpostaSostitutiva || 0)
  );
  const taxAmount = Number(taxAmountRaw.toFixed(2));

  if (isProfessional) {
    // Casse professionali: usa contributionBreakdown
    const breakdown = data.contributionBreakdown;
    return {
      taxAmount,
      inpsVariableAmount: 0,
      inpsFixedAmount: 0,
      contribSoggettivo: Number((breakdown?.soggettivo?.dovuto || 0).toFixed(2)),
      contribIntegrativo: Number((breakdown?.integrativo?.dovuto || 0).toFixed(2)),
      contribMaternita: Number((breakdown?.maternita?.importo || 0).toFixed(2)),
      contributionType: 'PROFESSIONAL'
    };
  } else {
    // INPS: logica esistente
    const inpsVariableAmountRaw = (
      (data.inpsSaldo || 0) +
      (data.firstAccontoINPS || 0) +
      (data.secondAccontoINPS || 0)
    );
    const inpsVariableAmount = Number(inpsVariableAmountRaw.toFixed(2));

    let inpsFixedAmountRaw = 0;
    if (contributionRegime.value === 'IVS_COMMERCIANTI') {
      inpsFixedAmountRaw = 4549.70;
    } else if (contributionRegime.value === 'IVS_ARTIGIANI') {
      inpsFixedAmountRaw = 4460.64;
    }
    const inpsFixedAmount = Number(inpsFixedAmountRaw.toFixed(2));

    return {
      taxAmount,
      inpsVariableAmount,
      inpsFixedAmount,
      contribSoggettivo: 0,
      contribIntegrativo: 0,
      contribMaternita: 0,
      contributionType: 'INPS'
    };
  }
};



const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

const getUserName = () => {
  return authStore.user.value?.name || 'Utente';
};

const getNextPayment = () => {
  if (!mappedLiquidityResults.value?.events) {
    return null;
  }

  const today = new Date();
  const accumuloEvents = mappedLiquidityResults.value.events
    .filter((event: any) => {
      const eventDate = new Date(event.date);
      return eventDate > today && event.category === 'ACCUMULO';
    })
    .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return accumuloEvents.length > 0 ? accumuloEvents[0] : null;
};

const getAvgMonthlyRate = () => {
  return mappedLiquidityResults.value?.metadata?.avgRate || null;
};

const getTotalDeposits = () => {
  return mappedLiquidityResults.value?.statistics?.totalDeposits || null;
};

// Load liquidity data when component mounts
const loadLiquidityData = async () => {
  try {
    const liquidityPayload = {
      action: "progressive_liquidity_scheduler",
      calculationData: mappedResults.value,
      formData: props.lastCalculation.input_data,
      useSafetyMargin: props.lastCalculation.input_data?.useSafetyMargin || false,
    };

    const liquidityResult = await calculateProgressiveLiquidity(liquidityPayload);
    liquidityApiResults.value = liquidityResult;
  } catch (error: any) {
    console.error("Errore caricamento dati liquidità:", error);
    liquidityApiResults.value = null;
  }
};

onMounted(() => {
  if (mappedResults.value.current) {
    loadLiquidityData();
  }
});
</script>

<style scoped>
/* Add any specific styles for dashboard display here */
</style>